<template>
    <span class="relative inline-flex rounded-lg overflow-hidden"
          v-if="Object.keys($i18n.availableLocales).length > 1">
        <button v-for="key in $i18n.availableLocales"
                :key="key" @click.prevent="setLocale(key)"
                type="button"
                :class="$i18n.locale === key ? buttonActiveClass : buttonClass"
                class="opacity-70 hover:opacity-100 relative inline-flex items-center px-4 py-2 text-sm uppercase leading-5 font-medium focus:focus:outline-none transition">
            {{ key }}
        </button>
    </span>
</template>

<script>
export default {
    name: 'LocaleToggle',

    props: {
        light: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            locale: null,
        };
    },

    created() {
        this.setLocale(localStorage.locale);
    },

    computed: {
        buttonClass() {
            if (this.light) {
                return 'bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-300';
            }
            return 'bg-gray-700 text-gray-300';
        },
        buttonActiveClass() {
            if (this.light) {
                return 'bg-gray-300 text-gray-800 dark:bg-gray-900 dark:text-white';
            }
            return 'bg-gray-900 text-white';
        },
    },

    methods: {
        setLocale(locale) {
            if (locale && this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
                this.$moment.locale(locale);
                localStorage.locale = locale;
                axios.get(route('locale', [locale]));
            }
        },
    },
};
</script>
